<template>
      <span>{{ params.value }}</span>
      <!-- <span>{{ UtilService.getMMDDYYYYDate(params.value) }}</span> -->
</template>

<script>
import UtilService from "@/services/UtilService";
export default {
  name: 'CellRendererDate',
  computed: {
    dateFormat(){
        if(this.params.value){
          return UtilService.getDDMMYYYYHHMMDate(this.params.value)
        }else{
          return ''
        }
    }
  }
}
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success),.15);
    color: rgba(var(--vs-success),1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning),.15);
    color: rgba(var(--vs-warning),1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger),.15);
    color: rgba(var(--vs-danger),1) !important;
    font-weight: 500;
  }
}
</style>
